import axios from "axios";
import logger from "../lib/logger";

const baseDomain = "https://suiboumap.gsi.go.jp";
const baseURL = `${baseDomain}/shinsuimap/Api/Public`;

const http = axios.create({
  baseURL,
});

http.interceptors.request.use((request) => {
  if (process.env.NODE_ENV === "development") {
    logger.debug(
      "[luRepository]API request url:" + request.baseURL + "/" + request.url
    );
  }
  return request;
});

http.interceptors.response.use(
  (response) => {
    return Promise.resolve({
      data: response.data,
    });
  },
  (error) => {
    logger.error("[luRepository]API response faild");
    return Promise.resolve({
      error: error.response,
    });
  }
);

export default http;
